export const getLiveMentoringUrl = (urls) => urls.liveMentoringUrl;

export const getUnLiveUrl = (urls) => urls.unLiveURL;

export const getLmpPlayerURL = (urls) => urls.lmpWebUrl;

export const getDoubtsBrowseUrl = (urls) => urls.doubtsBrowseUrl;

export const getSubjectiveTestEvalURL = (urls) => urls.subjectiveTestEvalURL;

export const getLMPAddToCanvas = (urls) => urls.lmpAddToCanvas;
